var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v("Search")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuClose" } },
              [
                _c("feather", {
                  staticClass: "svg_overflow",
                  attrs: { type: "x" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar-body" },
            [
              _vm.properties.uid
                ? _c(
                    "div",
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            form.attr != "clientid"
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", { attrs: { for: form.id } }, [
                                    _vm._v(_vm._s(form.name) + " "),
                                    form.division === "C" && form.attr
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tx-danger has-text-weight-semibold"
                                          },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.lazy",
                                        value: _vm.receptionData[form.id],
                                        expression: "receptionData[form.id]",
                                        modifiers: { lazy: true }
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "email",
                                      name: form.id,
                                      id: form.id,
                                      placeholder: form.name
                                    },
                                    domProps: {
                                      value: _vm.receptionData[form.id]
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.receptionData,
                                          form.id,
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: form.id } }, [
                                      _vm._v(_vm._s(form.name))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-field",
                                      [
                                        _c("b-autocomplete", {
                                          ref: "clientId",
                                          refInFor: true,
                                          attrs: {
                                            id: form.id,
                                            data: _vm.filteredClientDataArray,
                                            placeholder: form.name
                                          },
                                          on: {
                                            select: function(option) {
                                              return (_vm.selected = option)
                                            }
                                          },
                                          model: {
                                            value: _vm.clientId,
                                            callback: function($$v) {
                                              _vm.clientId = $$v
                                            },
                                            expression: "clientId"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                : _c(
                    "div",
                    [
                      _vm._l(_vm.inputSearchForms, function(form, i) {
                        return form.division === "C" &&
                          form.name != "Department" &&
                          form.name != "입고날짜"
                          ? _c("ul", { staticClass: "sidebar-nav" }, [
                              i === 0
                                ? _c(
                                    "li",
                                    { staticClass: "nav-label mg-b-10-f" },
                                    [_vm._v(" ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: form.id } }, [
                                  _vm._v(_vm._s(form.name) + " "),
                                  form.division === "C" && form.attr
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tx-danger has-text-weight-semibold"
                                        },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.lazy",
                                      value: _vm.receptionData[form.id],
                                      expression: "receptionData[form.id]",
                                      modifiers: { lazy: true }
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "email",
                                    name: form.id,
                                    id: form.id,
                                    placeholder: form.name
                                  },
                                  domProps: {
                                    value: _vm.receptionData[form.id]
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.receptionData,
                                        form.id,
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.inputSearchForms, function(form, i) {
                        return form.division === "C" &&
                          form.name != "Department" &&
                          form.name === "입고날짜"
                          ? _c("ul", { staticClass: "sidebar-nav" }, [
                              i === 0
                                ? _c(
                                    "li",
                                    { staticClass: "nav-label mg-b-10-f" },
                                    [_vm._v(" ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: form.id } }, [
                                  _vm._v(_vm._s(form.name) + " "),
                                  form.division === "C"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tx-danger has-text-weight-semibold"
                                        },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  { staticClass: "nav-item" },
                                  [
                                    _c("date-picker", {
                                      attrs: {
                                        config: _vm.datePickerOptions,
                                        autocomplete: "off",
                                        placeholder: "입고날짜",
                                        id: form.id,
                                        "aria-label": "Search",
                                        ignoreReadonly: ""
                                      },
                                      on: { "dp-change": _vm.dateKeyupEvent },
                                      model: {
                                        value: _vm.receptionData[form.id],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.receptionData,
                                            form.id,
                                            $$v
                                          )
                                        },
                                        expression: "receptionData[form.id]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  ),
              _vm._v(" "),
              _vm._l(_vm.inputCompanyForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  i === 0
                    ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                        _vm._v(" ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: form.id } }, [
                        _vm._v(_vm._s(form.name)),
                        form.division === "C" && form.attr
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "tx-danger has-text-weight-semibold"
                              },
                              [_vm._v("*")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-field",
                        [
                          _c(
                            "b-autocomplete",
                            {
                              ref: "companyName",
                              refInFor: true,
                              attrs: {
                                id: form.id,
                                data: _vm.filteredCompanyDataArray,
                                placeholder: form.name
                              },
                              on: {
                                select: function(option) {
                                  return (_vm.selected = option)
                                }
                              },
                              model: {
                                value: _vm.companyName,
                                callback: function($$v) {
                                  _vm.companyName = $$v
                                },
                                expression: "companyName"
                              }
                            },
                            [
                              _c("template", { slot: "empty" }, [
                                _vm._v("No results found")
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.inputClientForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  i === 0
                    ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                        _vm._v(" ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: form.id } }, [
                        _vm._v(_vm._s(form.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-field",
                        [
                          _c("b-autocomplete", {
                            ref: "clientId",
                            refInFor: true,
                            attrs: {
                              id: form.id,
                              data: _vm.filteredClientDataArray,
                              placeholder: form.name
                            },
                            on: {
                              select: function(option) {
                                return (_vm.selected = option)
                              }
                            },
                            model: {
                              value: _vm.clientId,
                              callback: function($$v) {
                                _vm.clientId = $$v
                              },
                              expression: "clientId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.checkboxSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: " d-block has-text-weight-semibold",
                          attrs: { for: "formGroupExampleInput" }
                        },
                        [_vm._v(_vm._s(form.name))]
                      ),
                      _vm._v(" "),
                      _vm._l(form.value, function(form1, i) {
                        return _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.receptionData[form.id],
                                  expression: "receptionData[form.id]"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "radio",
                                id: form1.codeCode,
                                name: form.id
                              },
                              domProps: {
                                value: form1.codeCode,
                                checked:
                                  form1.codeCode == _vm.receptionData[form.id],
                                checked: _vm._q(
                                  _vm.receptionData[form.id],
                                  form1.codeCode
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.receptionData,
                                    form.id,
                                    form1.codeCode
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: form1.codeCode }
                              },
                              [_vm._v(_vm._s(form1.codeName))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.dateSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: form.id } }, [
                        _vm._v(_vm._s(form.name) + " "),
                        form.division === "C" && form.attr
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "tx-danger has-text-weight-semibold"
                              },
                              [_vm._v("*")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      form.name == "생성일"
                        ? _c("p", { staticClass: "mg-b-0 text-left" }, [
                            _vm._v(_vm._s(_vm.receptionData[form.id]))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      form.name == "입고일"
                        ? _c("date-picker", {
                            staticClass: "form-control",
                            attrs: {
                              config: _vm.datePickerOptions,
                              autocomplete: "off",
                              placeholder: form.name,
                              id: form.id,
                              "aria-label": "Search",
                              ignoreReadonly: ""
                            },
                            model: {
                              value: _vm.receptionData[form.id],
                              callback: function($$v) {
                                _vm.$set(_vm.receptionData, form.id, $$v)
                              },
                              expression: "receptionData[form.id]"
                            }
                          })
                        : form.name == "완료예정일(TAT)"
                        ? _c("date-picker", {
                            staticClass: "form-control",
                            attrs: {
                              config: _vm.datePickerOptions,
                              autocomplete: "off",
                              placeholder: form.name,
                              id: form.id,
                              "aria-label": "Search",
                              ignoreReadonly: ""
                            },
                            model: {
                              value: _vm.receptionData[form.id],
                              callback: function($$v) {
                                _vm.$set(_vm.receptionData, form.id, $$v)
                              },
                              expression: "receptionData[form.id]"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("imgUpload", {
                    on: { imgFileHandler: this.imgFileHandler }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card card-body p-1 paste-background-color" },
                [
                  _c("input", {
                    staticClass: "img-input paste-background-color",
                    attrs: {
                      type: "text",
                      multiple: "multiple",
                      placeholder: "Paste your images here"
                    },
                    on: { paste: _vm.onPaste }
                  }),
                  _vm._v(" "),
                  _c("img", { attrs: { id: "pasteImg" } }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "m-0",
                    attrs: { id: "countPasteImg" }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("excelUpload", {
                    on: { excelFileHandler: this.excelFileHandler }
                  })
                ],
                1
              )
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content content-components pd-b-0-f overflow-hidden" },
        [
          _c(
            "div",
            { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
                },
                [
                  _c("div", [
                    _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                      _c(
                        "ol",
                        { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                        [
                          _c("li", { staticClass: "breadcrumb-item" }, [
                            _vm._v(_vm._s(this.mainName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "breadcrumb-item",
                              attrs: { "aria-current": "page" }
                            },
                            [_vm._v(_vm._s(this.subName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "breadcrumb-item active",
                              attrs: { "aria-current": "page" }
                            },
                            [_vm._v("Detail")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                        _vm._v(_vm._s(this.subName) + " Detail")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                          on: {
                            click: function($event) {
                              return _vm.confirmData()
                            }
                          }
                        },
                        [
                          _c("feather", {
                            staticClass: "wd-10 mg-r-5 svg_overflow",
                            attrs: { type: "folder" }
                          }),
                          _vm._v("Confirm")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                          on: {
                            click: function($event) {
                              return _vm.createData(true)
                            }
                          }
                        },
                        [
                          _c("feather", {
                            staticClass: "wd-10 mg-r-5 svg_overflow",
                            attrs: { type: "folder" }
                          }),
                          _vm._v("Save")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.properties.uid
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                              on: {
                                click: function($event) {
                                  return _vm.deleteData()
                                }
                              }
                            },
                            [
                              _c("feather", {
                                staticClass: "wd-10 mg-r-5 svg_overflow",
                                attrs: { type: "delete" }
                              }),
                              _vm._v("delete")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                          on: {
                            click: function($event) {
                              return _vm.goPage()
                            }
                          }
                        },
                        [
                          _c("feather", {
                            staticClass: "wd-10 mg-r-5 svg_overflow",
                            attrs: { type: "file" }
                          }),
                          _vm._v("List")
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "gel-container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "cart" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          { name: "draggable", rawName: "v-draggable" }
                        ],
                        staticClass: "items-list collapse",
                        staticStyle: { "max-width": "1500px" },
                        style: {
                          width:
                            _vm.imgData.length * 180 +
                            _vm.imgData.length * 20 +
                            "px"
                        },
                        attrs: { id: "ViewGel" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "viewer-scroll",
                            staticStyle: {
                              "white-space": "nowrap",
                              "overflow-x": "scroll"
                            }
                          },
                          [
                            _c("imageViewer", {
                              attrs: { image: _vm.imgData },
                              on: { deleteImgFile: this.deleteImgFile }
                            }),
                            _vm._v(" "),
                            _vm._m(2)
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._m(3)
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-none d-md-block tx-right-f mg-xs-y-15-f"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left",
                          attrs: {
                            href: "",
                            "data-toggle": "modal",
                            "data-animation": "effect-flip-horizontal"
                          },
                          on: { click: this.checkAll }
                        },
                        [
                          _c("feather", {
                            staticClass: "wd-10 mg-r-5 svg_overflow",
                            attrs: { type: "check" }
                          }),
                          _vm._v("Checked")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      this.downloadList.Excel.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                              on: {
                                click: function($event) {
                                  return _vm.excelDialogHandler()
                                }
                              }
                            },
                            [
                              _c("feather", {
                                staticClass:
                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                attrs: { type: "file-text" }
                              }),
                              _vm._v("Sample_List")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.imgData.length > 0
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-xs pd-x-15 btn-info btn-secondary btn-uppercase mg-l-5",
                              attrs: {
                                href: "",
                                "data-toggle": "modal",
                                "data-animation": "effect-flip-horizontal"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.dialogHandler("img")
                                }
                              }
                            },
                            [
                              _c("feather", {
                                staticClass:
                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                attrs: { type: "image" }
                              }),
                              _vm._v("SAMPLE BOX")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                          attrs: {
                            href: "#modal11",
                            "data-toggle": "modal",
                            "data-animation": "effect-flip-horizontal"
                          }
                        },
                        [
                          _c("feather", {
                            staticClass: "wd-10 mg-r-5 svg_overflow",
                            attrs: { type: "plus" }
                          }),
                          _vm._v("Add")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                          attrs: {
                            href: "",
                            "data-toggle": "modal",
                            "data-animation": "effect-flip-horizontal"
                          },
                          on: { click: this.sampleDelColumn }
                        },
                        [
                          _c("feather", {
                            staticClass: "wd-10 mg-r-5 svg_overflow",
                            attrs: { type: "minus" }
                          }),
                          _vm._v("Delete")
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("hot-table", {
                    ref: "sheet",
                    staticClass: "ht-hot-table",
                    attrs: {
                      id: "sample-table",
                      settings: _vm.sheetSettings,
                      data: _vm.sampleData,
                      afterChange: _vm.changeData
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-app",
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "space-around" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-dialog",
                            {
                              staticStyle: { "z-index": "20001" },
                              attrs: {
                                transition: "dialog-bottom-transition",
                                "max-width": "600"
                              },
                              model: {
                                value: _vm.imgDialog,
                                callback: function($$v) {
                                  _vm.imgDialog = $$v
                                },
                                expression: "imgDialog"
                              }
                            },
                            [
                              _c(
                                "v-carousel",
                                _vm._l(_vm.imgData, function(item, i) {
                                  return _c(
                                    "v-carousel-item",
                                    {
                                      key: item.id,
                                      attrs: {
                                        src:
                                          "data:" +
                                          item.type.trim() +
                                          ";base64," +
                                          item.img,
                                        "reverse-transition": "fade-transition",
                                        transition: "fade-transition"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            depressed: "",
                                            color: "primary",
                                            block: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.dialogHandler("delete")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDelete Image\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-dialog",
                                        {
                                          staticStyle: { "z-index": "20001" },
                                          attrs: {
                                            transition:
                                              "dialog-bottom-transition",
                                            "max-width": "300"
                                          },
                                          model: {
                                            value: _vm.deleteDialog,
                                            callback: function($$v) {
                                              _vm.deleteDialog = $$v
                                            },
                                            expression: "deleteDialog"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-center" },
                                            [
                                              _c(
                                                "v-sheet",
                                                {
                                                  staticClass:
                                                    "px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-body-2 mb-4"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Are you sure you want to delete this image? "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ma-1",
                                                      attrs: {
                                                        color: "grey",
                                                        plain: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.deleteDialog = false
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Cancel")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ma-1",
                                                      attrs: {
                                                        loading:
                                                          _vm.deleteLoading,
                                                        color: "error",
                                                        plain: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.deleteImgFile(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v(" Delete ")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal11",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel11",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14" }, [
                _vm._m(4),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: this.sampleAddColumn }
                    },
                    [_vm._v("Add")]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal14",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel14",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("v-app", { attrs: { id: "inspire" } }, [
        _c(
          "div",
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-dialog",
                  {
                    staticStyle: { "z-index": "20001" },
                    attrs: { "max-width": "500px" },
                    model: {
                      value: _vm.excelDialog,
                      callback: function($$v) {
                        _vm.excelDialog = $$v
                      },
                      expression: "excelDialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t\t\tDownload Report\n\t\t\t\t\t\t\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.downloadList["Excel"],
                                label: "Select a Excel",
                                "item-value": "text"
                              },
                              model: {
                                value: _vm.selectExcel,
                                callback: function($$v) {
                                  _vm.selectExcel = $$v
                                },
                                expression: "selectExcel"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "secondary", text: "" },
                                on: {
                                  click: function($event) {
                                    _vm.excelDialog = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tClose\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.loadExcel()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tLoad\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "accent", text: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteExcel_DialogHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tDelete\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "v-app",
        { attrs: { id: "inspire" } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", "max-width": "290" },
                  model: {
                    value: _vm.deleteExcelDialog,
                    callback: function($$v) {
                      _vm.deleteExcelDialog = $$v
                    },
                    expression: "deleteExcelDialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "text-h6" }, [
                        _vm._v(
                          "\n\t\t\t\tAre you sure you want to delete?\n\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "secondary", text: "" },
                              on: {
                                click: function($event) {
                                  _vm.deleteExcelDialog = false
                                }
                              }
                            },
                            [_vm._v("\n\t\t\t\tCancel\n\t\t\t\t")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteExcel()
                                }
                              }
                            },
                            [_vm._v("\n\t\t\t\tOK\n\t\t\t\t")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "sidebar-nav" }, [
      _c("li", { staticClass: "d-block mb-1 has-text-weight-semibold" }, [
        _vm._v("Sample Box Image upload")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "sidebar-nav", staticStyle: { "margin-top": "10px" } },
      [
        _c("li", { staticClass: "d-block mb-1 has-text-weight-semibold" }, [
          _vm._v("Sample List upload")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "view-cart" }, [
        _c(
          "span",
          {
            staticClass: "close-cart",
            attrs: { "data-toggle": "collapse", "data-target": "#ViewGel" }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel11" } },
        [_vm._v("Sample Create")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", { staticClass: "mg-b-0" }, [
        _vm._v("Please enter the number of samples to register.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mg-b-0" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("p", { staticClass: "mg-b-0" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: { type: "number", min: "1", max: "100", id: "addNum" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel14" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41a4accf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41a4accf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Reception/DetailForm.vue
// module id = null
// module chunks = 